/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Faq_A9Inputs */

const en_pc_faq_a9 = /** @type {(inputs: Pc_Faq_A9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. The MIT and Apache-2.0 licenses allow personal, business and government use at no cost. Companies can install PdfCraft on every desk, deploy the MSI silently, or host PdfCraft Online on their own intranet.`)
};

const zh_pc_faq_a9 = /** @type {(inputs: Pc_Faq_A9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以。MIT 和 Apache-2.0 许可证允许个人、企业和政府免费使用。公司可以在每台电脑上安装 PdfCraft、静默部署 MSI，或在内网中自行托管 PdfCraft 在线版。`)
};

/**
* | output |
* | --- |
* | "Yes. The MIT and Apache-2.0 licenses allow personal, business and government use at no cost. Companies can install PdfCraft on every desk, deploy the MSI sil..." |
*
* @param {Pc_Faq_A9Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_faq_a9 = /** @type {((inputs?: Pc_Faq_A9Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Faq_A9Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_faq_a9(inputs)
	return zh_pc_faq_a9(inputs)
});
export { pc_faq_a9 as "pc.faq.a9" }